import {
  useTranslation
} from "../../../chunk-6N4NEKWU.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/composite/Conversations/use-conversations-translation.ts
import { componentsI18n } from "../../../i18n/instance.mjs";
function useConversationsTranslation() {
  return useTranslation(void 0, { i18n: componentsI18n });
}
export {
  useConversationsTranslation
};
//# sourceMappingURL=use-conversations-translation.mjs.map